import { render, staticRenderFns } from "./StepQA.vue?vue&type=template&id=6b85f5d2&scoped=true"
import script from "./StepQA.vue?vue&type=script&lang=js"
export * from "./StepQA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85f5d2",
  null
  
)

export default component.exports